import { IconChevronLeft, IconX } from '@tabler/icons-react';
import styled from 'styled-components';
import { themeColors, themeSizes } from '../../styles/globalStyleVars';
import { TypographyStyled } from '../Styled/Typography';
import { IconButton } from '@cfa/react-core';

type SharedDrawerCustomHeaderProps = {
  title: string;
  onClose: () => void;
  onBack: () => void;
};

const HeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: white;
  height: 72px;
  min-height: 72px;
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 1;
  box-shadow: 0px 2px 4px 0px rgba(91, 103, 112, 0.24);
`;

const IconBackWrapper = styled.span`
  display: flex;
  align-items: center;
  color: ${themeColors.secondaryBlue};
  margin-left: ${themeSizes.sm};
  font-size: ${themeSizes.md};
`;

export const SharedDrawerCustomHeader = ({
  title,
  onClose,
  onBack,
}: SharedDrawerCustomHeaderProps) => {
  return (
    <HeaderWrapper>
      <IconButton
        aria-label='Back'
        color='secondary'
        onPress={onBack}
        style={{ padding: 0 }}
        data-testid='drawer-secondary-back-button'
      >
        <IconBackWrapper>
          <IconChevronLeft />
          Back
        </IconBackWrapper>
      </IconButton>
      <TypographyStyled
        text={title}
        fontWeight='medium'
        color={themeColors.secondaryBlue}
      />
      <IconButton
        aria-label='Close'
        color='secondary'
        onPress={onClose}
        style={{ marginRight: '14px' }}
      >
        <IconX />
      </IconButton>
    </HeaderWrapper>
  );
};
